import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import MembershipCategoryServices from '../../services/MembershipCategoryServices';

function AddMembershipCategory() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: '',
    // price: '',
    // durationDays: '',
    description: '',
    // maxOrdersPerDay: '',
    // maxDiscountPerOrder: '',
    // discountPercent: ''
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleNumberPaste = (e) => {
    const pasteData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      const payload = {
        name: formValues.name,
        // price: Number(formValues.price),
        // durationDays: Number(formValues.durationDays),
        description: formValues.description,
        // maxOrdersPerDay: Number(formValues.maxOrdersPerDay),
        // maxDiscountPerOrder: Number(formValues.maxDiscountPerOrder),
        // discountPercent: Number(formValues.discountPercent)
      };

      await MembershipCategoryServices.createMembershipCategory(payload);
      alert('Membership created successfully');
      navigate('/membership-category');

    } catch (error) {
      console.error('Failed to create Membership', error);
      alert('Failed to create Membership');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">Membership Category Add</h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active">Membership Category</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <div className="pe-1 mb-xl-0">
              <Link className="list-banner-btn" to="/membership-category"> Membership Category List</Link>
            </div>
          </div>
        </div>

        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                
                <div className="input-field">
                  <label>Name<span className="red">*</span></label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formValues.name}
                    onChange={handleInputChange}
                    className="form-control" 
                    placeholder='New Name' 
                  />
                </div>
{/* 
               <div className="input-field">
                  <label>Price<span className="red">*</span></label>
                  <input 
                    type="number" 
                    name="price" 
                    value={formValues.price}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control" 
             
                    placeholder='New Price' 
                  />
                </div>

                <div className="input-field">
                  <label>Duration Days<span className="red">*</span></label>
                  <input 
                    type="number" 
                    name="durationDays" 
                    value={formValues.durationDays}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control" 
                
                    placeholder='New Duration Days' 
                  />
                </div> */}

                <div className="input-field">
                  <label>Description<span className="red">*</span></label>
                  <textarea
                    name="description"
                    value={formValues.description}
                    onChange={handleInputChange}
                    className="form-control"
                 
                    placeholder="Enter Description"
                    style={{ height: "100px" }}
                  />
                </div>
{/* 
                <div className="input-field">
                  <label>Max Orders Per Day<span className="red">*</span></label>
                  <input 
                    type="number" 
                    name="maxOrdersPerDay" 
                    value={formValues.maxOrdersPerDay}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control" 
                
                    placeholder='New Max Orders Per Day' 
                  />
                </div>

                <div className="input-field">
                  <label>Max Discount Per Order<span className="red">*</span></label>
                  <input 
                    type="number" 
                    name="maxDiscountPerOrder" 
                    value={formValues.maxDiscountPerOrder}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control" 
              
                    placeholder='New Max Discount Per Order' 
                  />
                </div>

                <div className="input-field">
                  <label>Discount Percent<span className="red">*</span></label>
                  <input 
                    type="number" 
                    name="discountPercent" 
                    value={formValues.discountPercent}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control" 
                  
                    placeholder='New Discount Percent' 
                  />
                </div>  */}

                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddMembershipCategory